import { render, staticRenderFns } from "./OpQolForm.vue?vue&type=template&id=cf15396a&scoped=true&"
import script from "./OpQolForm.vue?vue&type=script&lang=js&"
export * from "./OpQolForm.vue?vue&type=script&lang=js&"
import style0 from "./OpQolForm.vue?vue&type=style&index=0&id=cf15396a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf15396a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VForm,VLayout,VRadio,VRadioGroup,VSelect,VSlider,VSpacer})
